<script lang="ts">
	import { getContext } from "svelte";
	import { twMerge } from "tailwind-merge";
	import Label from "#lib/components/Label.svelte";

	// properties forwarding
	export let color: "primary" | "red" = "primary";
	export let custom = false;
	export let inline = false;
	export let group: (string | number)[] | null = [];
	export let value: string | number = "on";
	export let checked: boolean | undefined = undefined;
	export let disabled = false;
	export let spacing: string = $$slots.default ? "me-2" : "";

	// tinted if put in component having its own background
	const background: boolean = getContext("background");

	// The following were originally exported from flowbite-svelte but are no longer
	// available from the package. Defining what we are using here.
	// ** Start
	const colorClasses: Record<"primary" | "red", string> = {
		primary: "text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600",
		red: "text-red-600 focus:ring-red-500 dark:focus:ring-red-600",
	};

	function labelClass(inline: boolean, extraClass: string) {
		return twMerge(inline ? "inline-flex" : "flex", "items-center", extraClass);
	}

	function inputClass(custom: boolean, color: "primary" | "red", rounded: boolean, tinted: boolean, spacing: string, extraClass: string) {
		return twMerge("w-4 h-4 bg-gray-100 border-gray-300 dark:ring-offset-gray-800 focus:ring-2", spacing, tinted ? "dark:bg-gray-600 dark:border-gray-500" : "dark:bg-gray-700 dark:border-gray-600", custom && "sr-only peer", rounded && "rounded", colorClasses[color], extraClass);
	}
	// ** End

	// react on external group changes
	function init(_: HTMLElement, _group: (string | number)[] | null) {
		if (checked === undefined) checked = _group?.includes(value) ?? false;
		onChange();

		return {
			update(_group: (string | number)[] | null) {
				checked = _group?.includes(value) ?? false;
			},
		};
	}

	function onChange() {
		// There's a bug in Svelte and bind:group is not working with wrapped checkbox
		// This workaround is taken from:
		// https://svelte.dev/repl/de117399559f4e7e9e14e2fc9ab243cc?version=3.12.1
		if (!group) group = [];
		const index = group.indexOf(value);

		if (checked === undefined) checked = index >= 0;

		if (checked) {
			if (index < 0) {
				group.push(value);
				group = group;
			}
		} else {
			if (index >= 0) {
				group.splice(index, 1);
				group = group;
			}
		}
	}
</script>

<Label {disabled} class={labelClass(inline, $$props.class)} show={$$slots.default}>
	<input use:init={group} {disabled} type="checkbox" bind:checked on:keyup on:keydown on:keypress on:focus on:blur on:click on:mouseover on:mouseenter on:mouseleave on:paste on:change={onChange} on:change {value} {...$$restProps} class={inputClass(custom, color, true, background, spacing, $$slots.default || $$props.class)} />
	<slot />
	<span class="sr-only">{$$props.title}</span>
</Label>
